define(['jquery', 'common', 'booking_rules', 'producthelper', 'warlist', 'responsive_common','expand_collapse'], function ($, ERVCommon, ERVBookingRules, ERVProductHelper, ERVWarList, ERVResponsiveCommon,ExpandCollapse) {
	var BookingStepOne = function () {
		var self = this;
		self.$ervBody = $('#erv-body');
		self.common = new ERVCommon();
		self.productHelper = new ERVProductHelper();
		self.bookingRules = new ERVBookingRules();
		self.warlist = new ERVWarList();
		self.responsiveCommon = new ERVResponsiveCommon();

		self.initContinueTriggers = function ($products) {
			$products.find('[data-js="continuetrigger"]').on('click', function (e) {
				self.common.forms.activateLoading($(this), true, e);
			});
		}

		self.initCompareContinueTriggers = function ($compareSection) {
			$compareSection.find('[data-js="compare-continuetrigger"]').on('click', function (e) {
				e.preventDefault();

				var $this = $(this),
					$product = self.$ervBody.find('input[value="' + $this.parent().data('productid') + '"]').parents('.product');

				if (!$product.length) { return; }

				if ($this.data('has-second-step')) {
					self.$ervBody.find('#selectProducts').trigger('click'); // switch to select view
					$product.find('[data-js="nexttrigger"]').trigger('click'); // trigger next step
					$.scrollTo($product, 300, { offset: -(self.$ervBody.find(self.responsiveCommon.isDeviceSize('small') ? '#header' : '#main-menu').height() + 10) });
				} else {
					$product.find('[data-js="continuetrigger"]').trigger('click');
				}
			});
		}

		self.initEventhandlers = function() {
			var $products = self.$ervBody.find('.product.booking');

			self.productHelper.productEventHandlers($products, '.product.booking');

			self.initContinueTriggers($products);
			
			self.$ervBody.find('.search-hits-header .form-element input[type=radio]').on('change', function () {
				var $input = $(this),
				$selectSection = self.$ervBody.find('[data-js="selectsection"]'),
				$compareSection = self.$ervBody.find('[data-js="comparesection"]');

				if ($input.val() === 'select') {
					$compareSection.addClass('hide');
					$selectSection.removeClass('hide');
				} else {
					// toggle annual/tripbytrip price, addons and type
					self.$ervBody.find('.same-products .selectable-products .insurance-type input:checked').each(function () {
						var $this = $(this), type = $this.data('js'), productId = $this.parents('form').find('input[name="ProductId"]').val(),
							productIndex = $compareSection.find('[data-productid="' + productId + '"]').index() + 1,
							$productTds = $compareSection.find('table tr td:nth-child(' + productIndex + ')');

						$productTds.find('[data-type="' + type + '"]').removeClass('hidden');
						$productTds.find('[data-type][data-type!="' + type + '"]').addClass('hidden');
					});

					// show compare
					$compareSection.removeClass('hide');
					$selectSection.addClass('hide');
				}
			});
		};

		self.setupSelectCompareView = function () {
			var $compareRadio = self.$ervBody.find('.search-hits-header .form-element #compareProducts');

			if ($compareRadio.length <= 0) {
				return; // no compare, nothing to setup
			}

			var $selectSection = self.$ervBody.find('[data-js="selectsection"]'),
				$compareSection = self.$ervBody.find('[data-js="comparesection"]'),
				$compareExport = self.$ervBody.find('#compare-export');

			self.initCompareContinueTriggers($compareSection);
			//this function is a fix for when the prop state is saved between pages
			if ($compareRadio.prop('checked')) {
				$compareSection.removeClass('hide');
				$selectSection.addClass('hide');
			}

			if ($compareExport.length) {
				$('body').on('bookingWidgetInitialized', function () {
					$compareExport.attr('href', $compareExport.attr('href') + '?query=' + encodeURIComponent(self.$ervBody.find('#booking-widget').serialize()));
				})
			}
		};

		self.WebKitFix = function() {
			if ('WebkitAppearance' in document.documentElement.style) {
				self.$ervBody.find('form').each(function () {
					var $form = $(this);

					$form.find('input').each(function() {
						var $input = $(this);
						if ($input.prop('checked') === false) {
							if ($input.attr('checked') === 'checked') {
								$input.prop('checked', true);
							}
						}
					});

					$form.find('select option').each(function() {
						var $option = $(this);
						if ($option.prop('selected') === false) {
							if ($option.attr('selected') === 'selected') {
								$option.prop('selected', true);
							}
						}
					});
				});
			}
		};
		
		self.getProducts = function () {

			var self = this, $editorBody = self.$ervBody.find('#main-content #product-result'), guid = self.$ervBody.find('#Guid').val();
			if (!guid.length) {
				return;
			}

			self.common.forms.activateLoadingHorizontal($editorBody.find('.page-width'));

			$.ajax({ type: 'GET', url: window.location.href.split('?')[0] + 'GetProducts', data: {guid : guid},
				success: function (data) {
					if (data) {
						$editorBody.html(data);
						self.initEventhandlers();
						self.WebKitFix();
						self.bookingRules.initHomeInsurance();
						self.common.framework.initTooltips('.tooltip');
						self.common.translate.initNoTranslate();
						ExpandCollapse.initExpandCollapse();

						self.setupSelectCompareView();
						$(document).trigger('products-loaded');

						var $containers = $editorBody.find('.table-compare-container');

						if (self.responsiveCommon.isDeviceSize('small')) {
							self.responsiveCommon.responsiveTable.initSmall($containers);
						} else {
							self.responsiveCommon.responsiveTable.initLarger($containers);
						}
					}
				},
				complete: function () {
					self.common.forms.deactivateLoadingHorizontal($editorBody);
				}
			});
		}
	};

	BookingStepOne.prototype.init = function () {
		var self = this;
		self.getProducts();
		self.warlist.init();
	}

	return BookingStepOne;
});